import type { Member, Snapshot } from "./types";

export interface ToastState {
  title: string;
  subtitle?: string;
  undo?: Member;
}

export const UNDO_TOAST_DURATION_MS = 10_000;

export function attendanceFeedback(
  member: Member,
  attending: boolean,
  before: Snapshot | null,
  next: Snapshot,
  locallyMarkedIDs: ReadonlySet<string>,
): ToastState {
  if (!attending) {
    return { title: `${member.name} set as not in attendance` };
  }

  const previouslyMarked = new Set(
    before?.members.filter((candidate) => candidate.attending).map((candidate) => candidate.id),
  );
  const newlyMarkedElsewhere = before
    ? next.members.filter(
        (candidate) =>
          candidate.attending &&
          !previouslyMarked.has(candidate.id) &&
          !locallyMarkedIDs.has(candidate.id),
      ).length
    : 0;

  return {
    title: `${member.name} marked attending`,
    ...(newlyMarkedElsewhere
      ? {
          subtitle: `${newlyMarkedElsewhere} ${newlyMarkedElsewhere === 1 ? "other" : "others"} marked elsewhere`,
        }
      : {}),
    undo: member,
  };
}
